import React from 'react';
import Routes from './routes';
import './App.scss';
import "react-datepicker/dist/react-datepicker.css";

const App = () => <Routes />;

export default App;
